<template>
  <div class="order-summary">
    <Loading v-if="pageLoading" />
    <Modal
      :modalMessage="modalMessage"
      @close-modal="closeModal"
      v-if="showNoOrderToShowModal"
    />
    <OrderSummaryModal
      v-if="OrderTimeOutModal"
      :modalMessage="modalMessage"
      @cancel-order="cancelOrderAfterWaiting"
      @wait-for-saviour="extendWaitForSaviour"
    />
    <div class="container">
      <div class="header">
        <h2>Order Summary</h2>
      </div>

      <!--
  v-if="cancelTotalSteps !== cancelCompletedSteps"
  -->
      <div class="body">
        <radial-progress-bar
          style="align-self:center; cursor:pointer;"
          v-if="cancelOrderInterface"
          :diameter="100"
          :completed-steps="cancelCompletedSteps"
          :total-steps="cancelTotalSteps"
          :animateSpeed="1000"
          :strokeWidth="5"
          :innerStrokeWidth="5"
          :startColor="`#e60000`"
          :stopColor="`#ff4d4d`"
        >
          <p @click.prevent="cancelOrder" style="text-align:center;">
            Cancel Order({{ cancelTotalSteps - cancelCompletedSteps }})
          </p>
        </radial-progress-bar>
        <h2>{{ this.orderedRestaurantName }}</h2>
        <h4>{{ this.orderedRestaurantLocation }}</h4>

        <OrderSummaryItemView
          :key="index"
          v-for="index in arrayIndexes"
          :itemName="orderedCart[index]"
          :itemValue="orderedCart[index + 1]"
          :itemQuantity="orderedCart[index + 2]"
        />
        <div class="price">
          <div class="price-breakdown">
            <div class="items-value">
              <div class="description">Item(s) Value</div>
              <div class="amount">S${{ this.orderedItemsValue }}</div>
            </div>
            <div class="saviour-charges">
              <div class="description">Saviour Perk/Reward</div>
              <div class="amount">S${{ this.orderedSaviourPerk }}</div>
            </div>
            <div class="app-charges">
              <div class="description">App Charges</div>
              <div class="amount">S${{ this.orderedAppCharges }}</div>
            </div>
          </div>
          <div class="total-price">
            <div class="description"><b>Total Price</b></div>
            <div class="amount">
              <b>S${{ this.orderedTotalPrice }}</b>
            </div>
          </div>
        </div>
        <div class="additional-requests" v-if="this.orderedAdditionalRequests">
          <b><p>Additional Requests:</p></b>
          <p>{{ this.orderedAdditionalRequests }}</p>
        </div>
        <div class="delivery-address">
          <b> <p>Delivery Address:</p></b>
          <p>{{ this.deliveryAddress }}</p>
        </div>

        <!--
  v-if="this.orderedSaviourName"
  -->
        <div class="saviour-details">
          <div class="header">
            <p>Whose Saving You?</p>
          </div>
          <div class="looking-for-saviour" v-if="!orderedSaviourAccepted">
            <div class="message">
              <p>Looking For a Saviour To Save Your Savour...</p>
            </div>
            <div class="progress-bar">
              <radial-progress-bar
                style="align-self:center;"
                :diameter="50"
                :completed-steps="lookingForSaviourCompletedSteps"
                :total-steps="lookingForSaviourTotalSteps"
                :animateSpeed="5000"
                :strokeWidth="4"
                :innerStrokeWidth="4"
                :startColor="`#E6E6FA`"
                :stopColor="`#7F00FF`"
              >
              </radial-progress-bar>
            </div>
          </div>
          <div class="saviour-credentials" v-if="orderedSaviourAccepted">
            <div class="saviour-name">
              <b><p>Saviour Name:</p></b>
              <p>
                {{ orderedSaviourName }}
                <!--
                {{ orderedSaviourName ? orderedSaviourName : "Saviour_Name" }}
                -->
              </p>
            </div>
            <div class="saviour-contact">
              <b><p>Saviour Contact:</p></b>
              <p>
                {{ orderedSaviourContact }}
                <!--
                {{ orderedSaviourContact ? orderedSaviourContact : "00000000" }}
                -->
              </p>
            </div>
          </div>
        </div>

        <!--
  v-if="orderedSaviourAccepted"
  -->
        <div class="order-status" v-if="orderedSaviourAccepted">
          <div class="header">
            <p>Order Status:</p>
          </div>
          <div class="saviour-accepted" v-if="orderAcceptedStatus">
            Order Has Been Accepted By Saviour. The Saviour Would Be Placing
            Your Order Shortly.
          </div>
          <div class="order-placed-at-restaurant" v-if="orderPlacedStatus">
            The Saviour Has Placed Your Order at
            {{ this.orderedRestaurantName }}.
          </div>
          <div class="order-picked-from-restaurant" v-if="orderPickedStatus">
            The Order Has Been Picked Up By The Saviour.
          </div>
          <div class="order-en-route" v-if="orderEnRouteStatus">
            The Saviour Is En Route To Save You!
          </div>
        </div>
      </div>

      <!--
    <p>Your Order Was Placed Successfully!</p>
    --></div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";
import Modal from "../components/Modal";
import Loading from "../components/Loading";
import OrderSummaryItemView from "../components/OrderSummaryItemView";
import OrderSummaryModal from "../components/OrderSummaryModal";
import RadialProgressBar from "vue-radial-progress";
//import RadialProgressBar2 from "vue-radial-progress";

export default {
  name: "OrderSummary",
  components: {
    Modal,
    Loading,
    OrderSummaryItemView,
    RadialProgressBar,
    OrderSummaryModal,
    //   RadialProgressBar2,
  },
  data() {
    return {
      pageLoading: false,
      showNoOrderToShowModal: false,
      modalMessage: null,
      userOrders: null,
      orderId: null,
      orderedCart: null,
      orderedTotalPrice: null,
      orderedItemsValue: null,
      orderedSaviourPerk: null,
      orderedAppCharges: null,
      orderedRestaurantDetails: null,
      orderedRestaurantName: null,
      orderedRestaurantLocation: null,
      orderedAdditionalRequests: null,
      orderedSaviourName: null,
      orderedSaviourContact: null,
      orderedSaviourAccepted: null,
      deliveryAddress: null,
      arrayIndexes: [],
      saviourData: null,
      cancelOrderInterface: true,
      cancelOrderInterval: null,
      cancelTotalSteps: 10,
      cancelCompletedSteps: 0,
      lookingForSaviourTotalSteps: 30,
      lookingForSaviourCompletedSteps: 0,
      OrderTimeOutModal: false,
      orderDeliveredInterval: null,
      orderAcceptedStatus: false,
      orderPlacedStatus: false,
      orderPickedStatus: false,
      orderEnRouteStatus: false,
    };
  },
  async mounted() {
    this.pageLoading = true;

    const dataBaseUser = await db
      .collection("users")
      .doc(firebase.auth().currentUser.uid);
    const dbResultsUser = await dataBaseUser.get();

    try {
      this.userOrders = dbResultsUser.data().orders;
      this.orderId = this.userOrders[this.userOrders.length - 1];

      const dataBaseOrders = await db.collection("orders").doc(this.orderId);
      const dbResultsOrders = await dataBaseOrders.get();

      if (
        dbResultsOrders.data().delivered ||
        dbResultsOrders.data().cancelled
      ) {
        this.modalMessage = "You Have Not Placed Any Order!";
        this.pageLoading = false;
        this.showNoOrderToShowModal = true;
        return;
      }

      this.orderedCart = dbResultsOrders.data().cart;
      this.orderedTotalPrice = dbResultsOrders.data().totalPrice;
      this.orderedItemsValue = dbResultsOrders.data().itemsValue;
      this.orderedSaviourPerk = dbResultsOrders.data().saviourPerk;
      this.orderedAppCharges = dbResultsOrders.data().appCharge;
      this.deliveryAddress = dbResultsOrders.data().userLocation;
      this.orderedAdditionalRequests = dbResultsOrders.data().additionalRequests;
      this.orderedRestaurantDetails = {
        name: dbResultsOrders.data().restaurantName,
        location: dbResultsOrders.data().restaurantLocation,
      };
      this.orderedRestaurantName = dbResultsOrders.data().restaurantName;
      this.orderedRestaurantLocation = dbResultsOrders.data().restaurantLocation;
      this.orderedSaviourAccepted = dbResultsOrders.data().acceptedBySaviour;
      this.orderedSaviourName = dbResultsOrders.data().saviourName;
      this.orderedSaviourContact = dbResultsOrders.data().saviourContact;

      if (this.orderedSaviourAccepted) {
        this.orderAcceptedStatus = true;
      }

      if (dbResultsOrders.data().orderPlacedAtRestaurant) {
        this.orderAcceptedStatus = false;
        this.orderPlacedStatus = true;
      }

      if (dbResultsOrders.data().orderPickedFromRestaurant) {
        this.orderPlacedStatus = false;
        this.orderPickedStatus = true;
      }

      if (dbResultsOrders.data().enRouteToSave) {
        this.orderPickedStatus = false;
        this.orderEnRouteStatus = true;
      }
    } catch (error) {
      console.log(error);
      this.modalMessage = "You Have Not Placed Any Order!";
      //this.modalMessage = "Error Getting Your Order Details(Error: " + error + ")";
      this.pageLoading = false;
      this.showNoOrderToShowModal = true;
      return;
    }

    for (let i = 1; i < this.orderedCart.length; i += 3) {
      this.arrayIndexes.push(i);
    }

    this.pageLoading = false;
    if (this.orderedSaviourAccepted) {
      this.cancelOrderInterface = false;
      //this.orderAcceptedStatus = true;
      this.checkOrderDelivered();
    } else {
      //this.getSaviourData();
      this.cancelOrderTime();
    }

    //this.$toast("Order Placed Successfully!");
  },
  beforeDestroy() {
    clearInterval(this.saviourData);
    clearInterval(this.cancelOrderInterval);
    clearInterval(this.orderDeliveredInterval);
  },
  methods: {
    checkOrderDelivered() {
      //const checkDeliveredStatusInMilliSeconds = 20000;
      //const checkDeliveredStatusInMilliSeconds = 2000;
      const checkDeliveredStatusInMilliSeconds = 10000;

      this.orderDeliveredInterval = setInterval(async () => {
        const dataBaseOrders = await db.collection("orders").doc(this.orderId);
        const dbResultsOrders = await dataBaseOrders.get();

        if (dbResultsOrders.data().orderPlacedAtRestaurant) {
          this.orderAcceptedStatus = false;
          this.orderPlacedStatus = true;
        }

        if (dbResultsOrders.data().orderPickedFromRestaurant) {
          this.orderPlacedStatus = false;
          this.orderPickedStatus = true;
        }

        if (dbResultsOrders.data().enRouteToSave) {
          this.orderPickedStatus = false;
          this.orderEnRouteStatus = true;
        }

        if (dbResultsOrders.data().delivered) {
          this.modalMessage =
            "Thank You For Using Our App! We Are Delighted To Save Your Savour!";
          this.showNoOrderToShowModal = true;
          clearInterval(this.orderDeliveredInterval);
          console.log("Order Delivered");
        }
      }, checkDeliveredStatusInMilliSeconds);
    },
    async cancelOrderAfterWaiting() {
      this.OrderTimeOutModal = false;
      this.pageLoading = true;
      const dataBaseOrders = await db.collection("orders").doc(this.orderId);
      await dataBaseOrders.update({
        cancelled: true,
      });

      console.log("Order Cancelled After Waiting!");
      this.pageLoading = false;
      this.$router.push({ name: "Dashboard" });
    },
    async cancelOrder() {
      this.pageLoading = true;
      const dataBaseOrders = await db.collection("orders").doc(this.orderId);
      await dataBaseOrders.update({
        cancelled: true,
      });
      clearInterval(this.cancelOrderInterval);
      this.cancelOrderInterface = false;
      this.pageLoading = false;
      this.modalMessage = "No Worries, Let Us Help You Find What You Like!";
      this.showNoOrderToShowModal = true;
      console.log("Order Cancelled!");
    },
    cancelOrderTime() {
      this.cancelOrderInterval = setInterval(() => {
        if (this.cancelCompletedSteps < this.cancelTotalSteps) {
          this.cancelCompletedSteps++;
        } else {
          this.cancelOrderInterface = false;
          this.getSaviourData();
          clearInterval(this.cancelOrderInterval);
        }
      }, 1000);
    },
    async getSaviourStatus() {
      const dataBaseOrders = await db.collection("orders").doc(this.orderId);
      const dbResultsOrders = await dataBaseOrders.get();

      this.orderedSaviourAccepted = dbResultsOrders.data().acceptedBySaviour;

      if (this.orderedSaviourAccepted) {
        this.orderAcceptedStatus = true;
        this.$toast("Found Saviour!");
        this.orderedSaviourName = dbResultsOrders.data().saviourName;
        this.orderedSaviourContact = dbResultsOrders.data().saviourContact;
        clearInterval(this.saviourData);
        //console.log("Found Saviour");
        this.checkOrderDelivered();
      }
    },
    extendWaitForSaviour() {
      this.OrderTimeOutModal = false;
      this.getSaviourData();
    },
    getSaviourData() {
      // Basically Doing for five minutes else cancelling the order
      const maxTime = 60;
      //const maxTime = 30;
      //const maxTime = 150;
      //const timeIntervalInMilliSeconds = 10000;
      //const timeIntervalInMilliSeconds = 2000;
      const timeIntervalInMilliSeconds = 5000;
      let timeDone = 0;

      this.lookingForSaviourTotalSteps = maxTime;
      this.lookingForSaviourCompletedSteps = 0;

      this.saviourData = setInterval(() => {
        if (timeDone < maxTime) {
          // Call a function to get saviour data every interval
          // Add additional checks like, if saviour found, good and stop interval
          // Optional : Add Cancel Timer, so as the user can cancel the order in 1 min if he likes.
          timeDone += 1;
          this.lookingForSaviourCompletedSteps += 1;
          this.getSaviourStatus();
          console.log("Trying to get saviour.");
        } else {
          // Cancel Order, update cancelled to true and modal showing sorry.
          this.modalMessage =
            "We're Extremely Sorry, But There's No Saviour For Your Rescue Now...";
          this.OrderTimeOutModal = true;
          console.log("Couldnt Get Saviour");
          clearInterval(this.saviourData);
        }
      }, timeIntervalInMilliSeconds);
    },
    closeModal() {
      this.$router.push({ name: "Dashboard" });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-summary {
  //overflow: auto;
  background-image: url("../assets/background/background19.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  //height: 100vh;

  .container {
    //width: 1000px;
    //height: 1000px;
    //background-color: #fff;
    max-width: 1000px;
    padding: 50px 25px;

    .header {
      h2 {
        color: #fff;
        text-align: center;
        font-weight: 300;
        margin: 16px 0;
        font-size: 32px;
        font-family: "Quicksand", sans-serif;
      }
    }

    .body {
      //filter: blur(8px);
      //-webkit-filter: blur(8px);
      //background-color: #f1f1f1;

      border-radius: 8px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.6);
      padding: 32px;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      max-width: 600px;
      margin: 32px auto;

      p {
        z-index: 101;
        color: #fff;
      }

      h2 {
        color: #fff;
        text-align: center;
        font-weight: 300;
        margin-bottom: 7px;
        font-size: 34px;
        font-family: "Quicksand", sans-serif;
      }

      h4 {
        color: #fff;
        text-align: center;
        font-weight: 200;
        margin-bottom: 5px;
        font-size: 17px;
        font-family: "Quicksand", sans-serif;
      }

      .price {
        display: flex;
        flex-direction: column;

        .description {
          flex-basis: 80%;
          text-align: left;
        }

        .amount {
          text-align: right;
          flex-basis: 20%;
        }

        .price-breakdown {
          color: rgb(100, 100, 100);
          padding-top: 10px;
          flex-basis: 72%;
          display: flex;
          flex-direction: column;

          .items-value {
            display: flex;
            flex-basis: row;
            flex-basis: 24%;
          }

          .saviour-charges {
            display: flex;
            flex-basis: row;
            flex-basis: 24%;
          }

          .app-charges {
            display: flex;
            flex-basis: row;
            flex-basis: 24%;
          }
        }

        .total-price {
          padding: 10px 0;
          color: #fff;
          font-size: 21px;
          display: flex;
          flex-direction: row;
          flex-basis: 28%;
        }
      }

      .additional-requests {
        font-size: 16px;
        margin-bottom: 10px;
        display: block;

        p {
          margin-bottom: 2px;
        }
      }

      .delivery-address {
        display: block;
        font-size: 16px;
        margin-bottom: 10px;

        p {
          margin-bottom: 2px;
        }
      }

      .saviour-details {
        .header {
          font-weight: bold;
          margin-bottom: 2px;
        }

        .looking-for-saviour {
          display: flex;
          flex-direction: row;
          align-items: center;

          .message {
            flex-basis: 80%;
            font-size: 16px;
          }

          .progress-bar {
            flex-basis: 20%;
          }
        }

        .saviour-credentials {
          font-size: 16px;
          //display: block;
          display: flex;
          flex-direction: row;
          //justify-content: space-between;

          .saviour-name {
            flex-basis: 50%;
            border-right: 1px #fff solid;
            text-align: left;
          }

          .saviour-contact {
            flex-basis: 50%;
            border-left: 1px #fff solid;
            text-align: right;
          }
        }
      }

      .order-status {
        margin-top: 10px;
        color: #fff;
        .header {
          font-weight: bold;
          margin-bottom: 2px;
        }
      }
    }
  }

  /*
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  */
}
</style>
